import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartPulse, Truck, Eye, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { DogTag } from "./Cosmetics";

const BOARDS = [
  { id: "medic", title: "Top Medic", sort: "revives", icon: HeartPulse, color: "#2ECC71", unit: "revives", metric: (u) => u.stats?.revives ?? 0 },
  { id: "driver", title: "Top Driver", sort: "logistics", icon: Truck, color: "#3498DB", unit: "logi ops", metric: (u) => (u.stats?.transports ?? 0) + (u.stats?.deploy_drives ?? 0) + (u.stats?.crate_deliveries ?? 0) },
  { id: "spotter", title: "Top Spotter", sort: "spots", icon: Eye, color: "#D4A94A", unit: "spots", metric: (u) => u.stats?.spots ?? 0 },
];

const RoleRanksStrip = () => {
  const [leaders, setLeaders] = useState({});

  useEffect(() => {
    Promise.all(BOARDS.map((b) => api.get("/leaderboard", { params: { sort: b.sort, limit: 1 } }).then((r) => r.data).catch(() => [])))
      .then(([medic, driver, spotter]) => setLeaders({ medic, driver, spotter }));
  }, []);

  const anyData = BOARDS.some((b) => { const l = (leaders[b.id] || [])[0]; return l && b.metric(l) > 0; });
  if (!anyData) return null;

  return (
    <section className="max-w-[1400px] mx-auto px-4 lg:px-8 mt-6" data-testid="home-role-ranks">
      <div className="flex items-center justify-between mb-3">
        <div className="overline"><HeartPulse className="inline w-3 h-3 mr-1" /> Teamplay Leaders</div>
        <Link to="/leaderboard" data-testid="home-role-ranks-viewall" className="text-sm font-stencil uppercase text-[#D4A94A] hover:text-[#E5BD60] inline-flex items-center gap-1">Role Ranks <ArrowRight className="w-3.5 h-3.5" /></Link>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        {BOARDS.map((b) => {
          const Icon = b.icon;
          const u = (leaders[b.id] || [])[0];
          const has = u && b.metric(u) > 0;
          return (
            <div key={b.id} data-testid={`home-role-${b.id}`} className="bg-[#13151B] border tactical-frame-sm p-4 flex items-center gap-3" style={{ borderColor: `${b.color}44` }}>
              <span className="w-9 h-9 tactical-frame-sm flex items-center justify-center border shrink-0" style={{ borderColor: b.color, background: `${b.color}18` }}><Icon className="w-5 h-5" style={{ color: b.color }} /></span>
              <div className="flex-1 min-w-0">
                <div className="overline text-[9px]" style={{ color: b.color }}>{b.title}</div>
                {has ? (
                  <div className="flex items-center gap-2 mt-0.5">
                    <DogTag frameId={u.equipped_frame} avatarUrl={u.avatar_url} callsign={u.callsign} size={22} isSupporter={u.is_supporter} />
                    <span className="font-stencil font-bold uppercase text-sm truncate">{u.callsign}</span>
                  </div>
                ) : (
                  <div className="font-mono text-[11px] text-[#64748B] mt-0.5">Be the first</div>
                )}
              </div>
              {has && (
                <div className="text-right shrink-0">
                  <div className="font-heading font-black text-xl" style={{ color: b.color }}>{b.metric(u).toLocaleString()}</div>
                  <div className="overline text-[9px]">{b.unit}</div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default RoleRanksStrip;
